import React from "react"
import { LoginScreenNavigationProps } from "./types"
import Login from "./login-screen"
import { PageRoot } from "~screens/page-root"

const LoginScreen: React.FC<LoginScreenNavigationProps> = () => {
  return (
    <PageRoot $background="#fff">
      <Login />
    </PageRoot>
  )
}

export default LoginScreen
